export default "__VITE_ASSET__ywQvh15Q__"